import React from 'react';
import PropTypes from 'prop-types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import GaleriaView from './View';
import EscolhaDasFotos from './EscolhaDasFotos';
import ModoDaGaleria from './ModoDaGaleria';
import { emEscolha } from './escolha';
import GaleriaSchema, { AJUDA } from './schema';

// No editor, a mesma galeria em modo de edição (avisos visíveis, sem botões
// nem janela) e, na barra lateral, o título opcional e, abaixo do formulário,
// o modo (./ModoDaGaleria.jsx) e, no modo de escolha, a lista das fotos da
// página com o campo de legenda (./EscolhaDasFotos.jsx).
const GaleriaEdit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const schema = GaleriaSchema();
  return (
    <>
      <GaleriaView {...props} emEdicao />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          description={AJUDA}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          footer={
            <>
              <ModoDaGaleria
                data={data}
                block={block}
                onChangeBlock={onChangeBlock}
              />
              {emEscolha(data) && <EscolhaDasFotos {...props} />}
            </>
          }
        />
      </SidebarPortal>
    </>
  );
};

GaleriaEdit.propTypes = {
  data: PropTypes.object.isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  properties: PropTypes.object,
};

export default GaleriaEdit;
